import React from 'react';
import { useSettings } from '@/context/SettingsContext';

const MemberPrintProfile = React.forwardRef(({ member, subscriptions, company }, ref) => {
  const { formatCurrency, formatDate } = useSettings();

  return (
    <div ref={ref} style={{ display: 'none' }}>
      <div style={{
        width: '210mm',
        minHeight: '297mm',
        padding: '20mm',
        margin: '0 auto',
        backgroundColor: 'white',
        fontFamily: 'Arial, sans-serif'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px', borderBottom: '3px solid #000', paddingBottom: '20px' }}>
          {company?.logo_url && (
            <img 
              src={`${process.env.REACT_APP_BACKEND_URL}${company.logo_url}`}
              alt="Company Logo" 
              style={{ maxHeight: '80px', maxWidth: '200px', margin: '0 auto 15px', display: 'block' }}
            />
          )}
          <h1 style={{ margin: '0', fontSize: '32px', fontWeight: 'bold' }}>{company?.name || 'Gym'}</h1>
          <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>{company?.address || ''}</p>
        </div>

        {/* Title */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ margin: '0', fontSize: '24px', textTransform: 'uppercase', letterSpacing: '2px' }}>
            Member Profile
          </h2>
        </div>

        {/* Personal Information */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ fontSize: '18px', borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '15px' }}>Personal Information</h3>
          <table style={{ width: '100%', fontSize: '14px' }}>
            <tbody>
              <tr>
                <td style={{ padding: '8px 0', width: '40%' }}><strong>Name:</strong></td>
                <td style={{ padding: '8px 0' }}>{member.name}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Email:</strong></td>
                <td style={{ padding: '8px 0' }}>{member.email}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Phone:</strong></td>
                <td style={{ padding: '8px 0' }}>{member.phone}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Emergency Contact:</strong></td>
                <td style={{ padding: '8px 0' }}>{member.emergency_contact}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Join Date:</strong></td>
                <td style={{ padding: '8px 0' }}>{formatDate(member.join_date)}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Status:</strong></td>
                <td style={{ padding: '8px 0', textTransform: 'uppercase' }}>{member.status}</td>
              </tr>
              {member.gender && (
                <tr>
                  <td style={{ padding: '8px 0' }}><strong>Gender:</strong></td>
                  <td style={{ padding: '8px 0', textTransform: 'capitalize' }}>{member.gender}</td>
                </tr>
              )}
              {member.date_of_birth && (
                <tr>
                  <td style={{ padding: '8px 0' }}><strong>Date of Birth:</strong></td>
                  <td style={{ padding: '8px 0' }}>{formatDate(member.date_of_birth)}</td>
                </tr>
              )}
              {member.height && (
                <tr>
                  <td style={{ padding: '8px 0' }}><strong>Height:</strong></td>
                  <td style={{ padding: '8px 0' }}>{member.height} cm</td>
                </tr>
              )}
              {member.weight && (
                <tr>
                  <td style={{ padding: '8px 0' }}><strong>Weight:</strong></td>
                  <td style={{ padding: '8px 0' }}>{member.weight} kg</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Admission Fee */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ fontSize: '18px', borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '15px' }}>Admission Fee</h3>
          <table style={{ width: '100%', fontSize: '14px' }}>
            <tbody>
              <tr>
                <td style={{ padding: '8px 0', width: '40%' }}><strong>Amount:</strong></td>
                <td style={{ padding: '8px 0' }}>{member.admission_fee_amount ? formatCurrency(member.admission_fee_amount) : 'N/A'}</td>
              </tr>
              <tr>
                <td style={{ padding: '8px 0' }}><strong>Payment Status:</strong></td>
                <td style={{ padding: '8px 0' }}>
                  <span style={{
                    padding: '4px 12px',
                    borderRadius: '4px',
                    backgroundColor: member.admission_fee_paid ? '#dcfce7' : '#fed7aa',
                    color: member.admission_fee_paid ? '#166534' : '#9a3412',
                    fontWeight: 'bold'
                  }}>
                    {member.admission_fee_paid ? 'PAID' : 'PENDING'}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Subscription History */}
        {subscriptions && subscriptions.length > 0 && (
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '18px', borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '15px' }}>Subscription History</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>Plan</th>
                  <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>Start Date</th>
                  <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>End Date</th>
                  <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'left' }}>Status</th>
                  <th style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.map((sub, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '10px' }}>{sub.plan_name || 'N/A'}</td>
                    <td style={{ border: '1px solid #ddd', padding: '10px' }}>{formatDate(sub.start_date)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '10px' }}>{formatDate(sub.end_date)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '10px', textTransform: 'uppercase' }}>{sub.status}</td>
                    <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'right' }}>{formatCurrency(sub.amount_due || 0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={{ marginTop: '50px', paddingTop: '20px', borderTop: '1px solid #ddd', textAlign: 'center', fontSize: '12px', color: '#666' }}>
          <p>Generated on {formatDate(new Date().toISOString())}</p>
          <p>{company?.name || 'Gym'} - {company?.phone || ''}</p>
        </div>
      </div>
    </div>
  );
});

MemberPrintProfile.displayName = 'MemberPrintProfile';

export default MemberPrintProfile;